import React from 'react'

import { useUIContext } from 'src/contexts/UIContext'

import css from './ShipmentsTitle.styles.scss'
import { ShipmentsTitleProps } from './ShipmentsTitle.types'

const ShipmentsTitle: React.FC<ShipmentsTitleProps> = ({ title, subtitle }) => {
  const { appWebView } = useUIContext()

  if (appWebView) {
    return null
  }

  return (
    <div className={css.ShipmentsTitle}>
      <h1>{title}</h1>
      {subtitle && <p>{subtitle}</p>}
    </div>
  )
}

export default ShipmentsTitle
